import React from 'react';
import {GalleryOverlayBar} from './GalleryOverlayBar';
import {Features} from './GalleryOverlayBar/Features';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {FavouriteButton} from 'components/ProductSnippetNew/components/ProductSnippetHeader/GalleryOverlayBar/FavouriteButton';

type TProductSnippetHeaderProps = Pick<
    IProductSnippet,
    'id' | 'ratings' | 'reviewsCount' | 'reviewsUrl' | 'isFineAndRare' | 'wishlist' | 'stickers'
> &
    Pick<IProductSnippet['analytics'], 'onReviewsClick'> & {
        isFirstImageActive?: boolean;
    };

export const ProductSnippetHeader = (props: TProductSnippetHeaderProps) => {
    const {
        ratings,
        reviewsCount,
        reviewsUrl,
        isFineAndRare,
        stickers,
        onReviewsClick,
        wishlist,
        isFirstImageActive = true,
    } = props;

    return (
        <>
            <GalleryOverlayBar
                leftSlot={
                    <>
                        <Features
                            ratings={ratings}
                            stickers={stickers}
                            reviewsCount={reviewsCount}
                            reviewsUrl={reviewsUrl}
                            onReviewsClick={onReviewsClick}
                            isFineAndRare={isFineAndRare}
                            isFirstImageActive={isFirstImageActive}
                        />
                    </>
                }
                rightSlot={<FavouriteButton {...wishlist} />}
            />
        </>
    );
};
